import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=b9c3b6f6"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports